import { useEffect } from "react";
import { useParams } from "react-router-dom";
import ReactGA from "react-ga4";

import playstore from "../assets/DownloadApp/googleplay.png";
import appstore from "../assets/DownloadApp/appstore.png";
import weu from "../assets/DownloadApp/weucopy.png";
import phone from "../assets/DownloadApp/app.png";

function DownloadApp() {
  const { source } = useParams();

  useEffect(() => {
    ReactGA.send({
      hitType: "pageview",
      page: `/hello/${source}`,
      campaign: source,
    });

    const userAgent = navigator.userAgent || navigator.vendor || window.opera;

    const playStoreURL = "https://play.google.com/store/apps/details?id=com.weuapp"; 
    const appStoreURL = "https://apps.apple.com/app/id6748490589"; 

    if (/android/i.test(userAgent)) {
      window.location.href = playStoreURL;
    } else if (/iPad|iPhone|iPod/.test(userAgent)) {
      window.location.href = appStoreURL;
    }
  }, [source]);

  const gradientStyle = {
    background: "linear-gradient(to bottom, white, #47B7D1)",
    display: "flex",
  };

  return (
    <div style={gradientStyle} className="h-screen justify-center items-start">
      <div className="flex flex-col pt-10">
        <div className="flex justify-between items-center p-7">
          <div>
            <img src={weu} alt="WEU logo" />
          </div>
          <div className="flex flex-col space-y-1 items-start">
            <p className="text-[#0F1E6C] text-xs pb-2 font-bold lg:text-lg">
              지금 앱을 다운로드하세요!
            </p>
            <img src={playstore} alt="Play Store" />
            <img src={appstore} alt="App Store" />
          </div>
        </div>
        <div className="pt-5">
          <img src={phone} alt="Phone app preview" />
        </div>
      </div>
    </div>
  );
}

export default DownloadApp;
